import { EMPTY_RESUME_SG_CHARGE_SEARCH_CRITERIA } from "domain/entity/ResumeSGCharge/ResumeSGChargeSearchCriteria";
import { getDefaultBuConfig } from "domain/repository/apiUtil";
import moment from "moment";
import { useResumeSGChargeVM } from "presentation/hook/ResumeSGCharge/useResumeSGChargeVM";
import { useResumeSGChargeTracked } from "presentation/store/ResumeSGCharge/ResumeSGChargeProvider";
import { memo, useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import ResumeSGChargeSearchPanel from "./ResumeSGChargeSearchPanel";
import ResumeSGChargeTablePanel from "./ResumeSGChargeTablePanel";
import ResumeSGChargeTitleBar from "./ResumeSGChargeTitleBar";

const ResumeSGChargeMaintenance: React.FC = () => {
    const [resumeSGChargeState] = useResumeSGChargeTracked();
    const resumeSGChargeVM = useResumeSGChargeVM();
    const [isLoading, setIsLoading] = useState(true);
    const { isShowSearchPanel } = resumeSGChargeState;

    useEffect(() => {
        const initialScreen = async () => {
            let newSearchCriteria = { ...EMPTY_RESUME_SG_CHARGE_SEARCH_CRITERIA }
            newSearchCriteria = {
                ...newSearchCriteria,
                opsDateFrom: moment().subtract(getDefaultBuConfig("REACT_APP_SEARCH_DATA_DEFAULT_DATE_RANGE"), "days").startOf("day").toDate(),
                opsDateTo: moment().endOf("day").toDate(),
            };
            setIsLoading(true);
            resumeSGChargeVM.setIsSearchLoading(true);
            await Promise.allSettled([
                resumeSGChargeVM.loadDropdownOption(),
                resumeSGChargeVM.onSearch(newSearchCriteria),
            ]);
        };

        initialScreen().then((data) => {
            setIsLoading(false);
            resumeSGChargeVM.setIsSearchLoading(false);
        }).catch(error => {
            setIsLoading(false);
            resumeSGChargeVM.setIsSearchLoading(false);
        });

    }, [resumeSGChargeVM]);

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper${isShowSearchPanel ? '' : ' im-hide-side-form-draggable'}`}>

            {<>
                <ResumeSGChargeTitleBar />
                <SliderPanel
                    isOpen={true}
                    draggable={false}
                    leftSectionWidth={isShowSearchPanel ? "30%" : "0%"}
                    rightSectionWidth={isShowSearchPanel ? "70%" : "100%"}
                    leftChildren={<ResumeSGChargeSearchPanel />}
                    rightChildren={<ResumeSGChargeTablePanel />}
                />
            </>}
        </div>
    </>
}

export default memo(ResumeSGChargeMaintenance);